import { EnumNewsStatus, EnumNewsType } from 'utils';
import { GET, POST, PUT, DELETE } from './serve';
import { Api } from './typings';

// newsType:  1 blog 2 media 3 social
// 获取blog分页
export const reqBlogListByPage = (data) => {
  const params = {
    ...data,
    newsType: EnumNewsType.BLOG,
    status: EnumNewsStatus.ON,
  };
  return GET('/news/page')(params);
};

// 获取media分页
export const reqMediaListByPage = (data) => {
  const params = {
    ...data,
    newsType: EnumNewsType.MEDIA,
    status: EnumNewsStatus.ON,
  };
  return GET('/news/page')(params);
};

// 获取social分页
export const reqSocialListByPage = (data) => {
  const params = {
    ...data,
    newsType: EnumNewsType.SOCIAL,
    status: EnumNewsStatus.ON,
  };
  return GET('/news/page')(params);
};

export const reqSocialList = (): Promise<Api.INewsItem[]> => {
  const params = {
    newsType: EnumNewsType.SOCIAL,
    status: EnumNewsStatus.ON,
  };
  return GET('/news')(params);
};

// 获取news info
export const reqNewsInfo = (data: { id: string | number }) => {
  const params = {
    ...data,
  };
  return GET(`/news/${params.id}`)(params);
};
